import React, { useState } from 'react'
import {useNavigate} from 'react-router-dom';

const Login = (props) => {
    const [credentials,setCredentials]=useState({email:'', password:''})
    const navigate = useNavigate();
    const handleSubmit= async (e)=>{
        e.preventDefault();
       
            //API Call
            const response = await fetch("http://localhost:5000/api/auth/login", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",

              },
              body: JSON.stringify({ email: credentials.email,password:credentials.password }),
            });
            const json= await response.json()
            console.log(json)
            if (json.success){
                localStorage.setItem('authtoken' ,json.authToken)
                props.showAlert ('Logged In Successfully','success')
                navigate('/');
            }
            else{
                  props.showAlert ('Invalid Details','danger')
                }
            

        }
        const onChange=(e)=>{
            setCredentials({...credentials, [e.target.name]:e.target.value})
        }


  return (
    <div className='mt-2'> 
      <h2 className='my-2'>Login to continue with ICloud</h2>
      <form onSubmit={handleSubmit}>
  <div className="my-3">
    <label htmlFor="email" className="form-label">Email address</label>
    <input type="email" className="form-control" name='email'onChange={onChange} id="email" value={credentials.email} aria-describedby="emailHelp"/>
    
  </div>
  <div className="my-3">
    <label htmlFor="password" className="form-label">Password</label>
    <input type="password" className="form-control" name='password' onChange={onChange} id="password" value={credentials.password}/>
  </div>
  
  <button type="submit" className="btn btn-primary" >Submit</button>
</form>
    </div>
  )
}

export default Login
